<div class="row w-100 d-flex p-1 align-items-center">
    <div class="col-9 firstcol text-truncate">{{reason.reason}}</div>
    
    <div class="col-3 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
            <li><a class="dropdown-item pt-1 pb-1" translate="Button.Delete" (click)="removeReason(reason.id!)"></a></li>
            </ul>
        </div>
    </div>
</div>